import { getConditionsFilterConfig } from '../filters/condition';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { getDefaultShopConfig } from './default';

export const loveveryShopConfig = {
  ...getDefaultShopConfig(),
  filters: [getBrandDirectFilterConfig(), getConditionsFilterConfig()],
};
